<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-selector-block">
          <div class="e-row e-row--gutters">
            <div class="e-col e-col-sm-12">
              <div class="e-block__title e-block__title--mb16" v-if="!!currentQuestion.enterIncoming">Goal & Incoming Temperature (°F)</div>
              <div class="e-block__title e-block__title--mb16" v-else> {{ currentQuestion.title || 'Goal Temperature (°F)' }}</div>
              <div class="e-block__text e-block__text--mb16">{{ currentQuestion.text || 'Eemax issues all Residential type water heaters set at 120°F, which can be field-adjusted up to 140°F or down to just below 100°F.' }}</div>
              <div class="e-block__text e-block__text" v-if="!!currentQuestion.enterIncoming">Since you are using this unit as a booster, please enter in your preheated incoming temperature (°F) that the unit will be boosting the water temperature from, to get to 120°F.</div>
            </div>
            <div class="e-col e-col-sm-12">
              <div class="e-block__form">
                <div class="e-block__form-row">
                  <div class="e-block__form-label">
                    {{ currentQuestion.locked === false ? 'Enter goal temperature °F' : 'Standard residential goal temperature °F'}}
                  </div>
                  <input type="text"
                         class="e-input"
                         :readonly="currentQuestion.locked !== false"
                         v-model="value"
                         @keypress="isNumber">
                  <div class="e-input__hint" v-if="currentQuestion.hint" v-html="currentQuestion.hint"></div>
                </div>
                <div class="e-block__form-row" v-if="!!currentQuestion.enterIncoming">
                  <div class="e-block__form-label">Enter Incoming temperature °F</div>
                  <input type="text"
                         class="e-input"
                         v-model="incoming"
                         @keypress="isNumber">
                  <div class="e-input__hint">If you are uncertain, it is recommended that you confirm & enter that below, otherwise leave at the default entry which is close to ambient temperature of 70(°F):</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <tip v-if="currentQuestion.tip" :text="currentQuestion.tip" />
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row e-row--gutters">
        <div class="e-col-auto e-col-sm-6 e-order-sm-2">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
        <div class="e-col-auto e-col-sm-6 e-order-sm-3">
          <button class="e-btn e-btn--help e-btn--no-text" @click.prevent="nextQuestion(needHelp)"><span>Help</span></button>
        </div>
        <div class="e-col"></div>
        <div class="e-col-auto e-col-sm-12 e-order-sm-1">
          <button class="e-btn e-btn--next" @click.prevent="proceed(value)" :disabled="disabledBtn">Proceed</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { needHelp } from '@/utils/residential-flow';
import Tip from '@/components/ui/Tip.vue';

export default {
  components: {
    Tip,
  },
  name: 'Selector',
  data() {
    return {
      value: 120,
      incoming: 70,
      needHelp,
    };
  },
  mounted() {
    if (this.currentQuestion.defaultValue) {
      this.value = this.currentQuestion.defaultValue;
    }
    const link = document.querySelector('.e-assistance');
    if (link) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextQuestion(needHelp);
      });
    }
  },
  computed: {
    ...mapState(['selectedFlow', 'containerHeight']),
    ...mapGetters(['currentQuestion']),
    disabledBtn() {
      return (!this.incoming || +(this.incoming) <= 0) || !this.value || +(this.value) <= 0;
    },
  },
  methods: {
    ...mapActions(['previousQuestion', 'nextQuestion', 'addParamToFilter']),
    previous() {
      this.previousQuestion();
    },
    proceed(value) {
      this.addParamToFilter({ name: this.currentQuestion.paramName, value });
      if (this.currentQuestion.enterIncoming) {
        this.addParamToFilter({ name: 'temp-in', value: this.incoming });
      }
      this.nextQuestion(this.currentQuestion.nextId);
    },
    isNumber(evt) {
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">

</style>
